<template>
    <div>
      <b-tabs content-class="mt-3" v-model="tabIndex">
        <!--<b-tab title="Összegzés" lazy>
          <totals/>
        </b-tab>-->
        <b-tab title="Tesztek" lazy>
          <tests/>
        </b-tab>
        <!--<b-tab title="Iparág"  lazy>
          <industry/>
        </b-tab>-->
      </b-tabs>
    </div>
</template>
<script>
  import Totals from './totals/Totals.vue'
  import Tests from './tests/Tests.vue'
  import Industry from './industry/Industry.vue'

  export default {
    components: {
      'totals': Totals,
      'tests': Tests,
      'industry': Industry,
    },
    data() {
      return {
        tabIndex: 0
      }
    },
    errorCaptured(err, vm, info) {
      this.$bvToast.toast('Hiba történt a művelet közben!', {
        title: 'Hiba',
        variant: 'danger',
        autoHideDelay: 5000,
        appendToast: true
      })
      console.error(err)

      return false
    },
  }
</script>